<template>
  <fieldset class="c-rap-upload-box-wrapper">
    <legend>
      <h3 v-if="title" class="c-rap-upload-box__title">{{ title }}</h3>
    </legend>
    <div class="c-rap-upload-box__intro" v-html="intro"></div>
    <validation-message
      :valid="files.length && !extensionError && !nameError"
      :invalid="extensionError || nameError"
      :validationMessage="extensionError ? errorMessage('extension') : null"
    >
      <template v-show="files.length">
        <div
          class="c-rap-upload-box__wrapper"
          v-for="file in files"
          v-bind:key="file.id"
        >
          <div class="c-rap-upload-box__file">
            <span class="c-rap-upload-box__name">
              {{ file.name }} ({{ file.size | formatFileSize }})
            </span>
            <span class="c-rap-upload-box__status" v-if="file.error">
              {{ errorMessage(file.error) }}
            </span>
            <span class="c-rap-upload-box__status" v-if="extensionError">
              {{ errorMessage("extension") }}
            </span>
            <span class="c-rap-upload-box__status" v-if="nameError">
              {{ errorMessage("name") }}
            </span>
            <span class="c-rap-upload-box__status" v-else-if="file.success">
              Done
            </span>
            <span
              class="c-rap-upload-box__progress"
              aria-valuemax="100"
              aria-valuemin="0"
              v-bind:aria-valuenow="file.progress"
              v-else-if="file.active || file.progress !== '0.00'"
            >
              <span
                class="c-rap-upload-box__progress-bar"
                role="progressbar"
                v-bind:style="{ width: file.progress + '%' }"
              >
                {{ file.progress }}%
              </span>
            </span>
          </div>
          <div class="c-rap-upload-box__actions">
            <button
              class="c-button c-button--brand c-button--text-center"
              type="button"
              v-on:click.prevent="$refs.upload.update(file, { active: true })"
              v-if="!file.success && !extensionError"
            >
              Upload
            </button>
            <button
              class="c-button c-button--brand c-button--text-center"
              type="button"
              v-on:click.prevent="removeUpload(file)"
              v-if="!file.success"
            >
              Reset
            </button>
          </div>
        </div>
      </template>

      <div class="c-rap-upload-box__drag-drop" v-show="!files.length">
        <div class="c-rap-upload-box__container">
          <span>Please either drag a file here or</span>
          <div class="c-rap-upload-box">
            <label
              class="c-button c-button--link c-rap-upload-box__label"
              v-bind:for="inputId"
            >
              <file-upload
                ref="upload"
                class="visually-hidden"
                v-bind:drop="drop"
                v-bind:drop-directory="dropDirectory"
                v-bind:input-id="inputId"
                v-bind:multiple="multiple"
                v-bind:name="inputId"
                v-bind:post-action="uploadPostAction"
                v-bind:size="size"
                v-model="files"
                v-on:input-filter="inputFilter"
                v-on:input-file="inputFile"
              >
              </file-upload>
              choose a file to upload
            </label>
          </div>
        </div>
      </div>
    </validation-message>
  </fieldset>
</template>

<script>
  import FileUpload from "vue-upload-component";
  import ValidationMessage from "../../../../base/validation-message/ValidationMessage.vue";

  export default {
    components: {
      FileUpload,
      ValidationMessage,
    },
    props: {
      extensions: {
        required: true,
        type: Array,
      },
      title: {
        required: false,
        type: String,
      },
      intro: {
        required: false,
        type: String,
      },
      uploadPostAction: {
        required: true,
        type: String,
      },
      required: {
        required: true,
        type: Boolean,
      },
      valid: {
        type: Boolean,
        default: null,
      },
      invalid: {
        type: Boolean,
        default: null,
      },
      validationMessage: {
        required: false,
        type: String,
      },
    },
    data() {
      return {
        extensionError: false,
        nameError: false,
        drop: true,
        dropDirectory: true,
        files: [],
        inputId: "fileUpload",
        multiple: false,
        isUploadingFile: false,
        size: 70 * 1024 * 1024, // 70 MB
      };
    },
    computed: {
      fileTypeRegex() {
        return this.extensions.join("|");
      },
    },
    methods: {
      triggerFileInput() {
        const fileInput = document.getElementById(this.inputId);
        if (fileInput) {
          fileInput.click();
        }
      },
      cancelUpload() {
        this.$refs.upload.active = false;
      },
      errorMessage(key) {
        const errorMessages = {
          abort: "Error: Upload aborted",
          denied: "Error: Network error",
          extension:
            "Error: Only JPG, PNG, MP4, MPG, MKV, MOV, and AVI file types permitted",
          network:
            "Error: Please check the file contents to ensure they meet the correct format and size and try again later",
          server:
            "Error: Please check the file contents to ensure they meet the correct format and size and try again later",
          size: "Error: File too large",
          timeout: "Error: Upload timed out",
          name:
            "Error: Please upload a file with a name that’s less than 300 characters long.",
        };

        return errorMessages[key];
      },
      inputFilter(newFile, oldFile, prevent) {
        if (newFile && !oldFile) {
          const re = new RegExp(`\\.(${this.fileTypeRegex})$`, "i");
          if (!re.test(newFile.name)) {
            this.extensionError = true;
          }
          if (newFile.name.length >= 300) {
            this.nameError = true;
          }
        }
      },
      inputFile(newFile, oldFile) {
        if (!this.isUploadingFile && this.files.length > 0) {
          this.$emit("isUploadingFile", true);
        }
        if (newFile && oldFile) {
          if (newFile.active && !oldFile.active) {
            this.$refs.upload.update(newFile, {
              active: true,
              error: "",
              progress: "0.00",
            });
          }

          if (newFile.success && !oldFile.success) {
            this.$emit("fileUpload", newFile.response, this.files[0]);
          }
        }
      },
      removeUpload(file) {
        this.$emit("resetFile", false);
        this.$emit("isUploadingFile", false);
        this.$refs.upload.remove(file);
        this.extensionError = false;
        this.nameError = false;
      },
    },
  };
</script>



// WEBPACK FOOTER //
// src/components/components/reportAProblem/_contact-us-rap/_vue/UploadBox.vue